import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CautionIcon from "assets/images/icons/caution.svg";

const useStyles = makeStyles(() => ({
  root: {
    width: 560,
    "& button": {
      margin: "0 8px",
    },
  },
}));

const DEFAULT_MESSAGE = `
  Custom panel does not meet the minimum requirements to enable robust baselining
  to power the CNV algorithm. Please consider using a catalog panel as a base for
  the custom design or adding additional gene modules. You may proceed to ordering
  the panel as is, but CNV functionality will not be optimal.
`;

const CustomizeConfirmDialog = ({
  resolve,
  message,
  confirmText = "Compare",
}: {
  resolve: { fn: (val: boolean) => void } | null;
  message: string;
  confirmText?: string;
}) => {
  const classes = useStyles();

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={!!resolve}
      classes={{ paper: classes.root }}
    >
      <DialogTitle>
        <Typography variant="h2" align="center">
          Alert
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box textAlign="center">
          <img src={CautionIcon} alt="Caution Icon" />
        </Box>
        <Box mt={3}>
          <Typography variant="body1" align="center">
            {message ?? DEFAULT_MESSAGE}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" my={3}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={() => resolve?.fn(true)}
          >
            {confirmText}
          </Button>
          <Button
            size="large"
            variant="outlined"
            color="primary"
            onClick={() => resolve?.fn(false)}
          >
            Continue editing
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CustomizeConfirmDialog;
